import { useAvailableDimensions } from '../../../hooks/ui/useAvailableDimensions';
import { } from 'react-native';

export const useAnswerWidth = () => {
  const {width} = useAvailableDimensions();
  return 0.8*width;
};